import { CdpaButtonComponent, CdpaButtonId } from "../../../common/components/cdpaButton.component";
import { FormId } from "../common/formId";
import "./delete-account-confirm.scss";
export class DeleteAccountConfirm {
    constructor() {
        this.cancelFormId = "delete-account-cancel-form";
        this.modalClass = "cdpa-modal";
        this.modalHiddenClass = `${this.modalClass}--hidden`;
        this.confirmButton = new CdpaButtonComponent(CdpaButtonId.DeleteAccountConfirm);
        this.cancelButton = new CdpaButtonComponent(CdpaButtonId.DeleteAccountCancel);
        this.modalCancelButton = new CdpaButtonComponent(CdpaButtonId.DeleteAccountModalCancel);
        this.finalConfirmButton = new CdpaButtonComponent(CdpaButtonId.DeleteAccountFinalConfirm);
        this.modalElement = document.getElementsByClassName(this.modalClass)[0];
        this.confirmButton.onClick$.subscribe(() => {
            this.showModal();
        });
        this.cancelButton.onClick$.subscribe(() => {
            document.getElementById(this.cancelFormId).submit();
        });
        this.modalCancelButton.onClick$.subscribe(() => {
            this.hideModal();
        });
        this.finalConfirmButton.onClick$.subscribe(() => {
            this.modalCancelButton.setDisabled(true);
            this.finalConfirmButton.isLoading = true;
            document.getElementById(FormId.DeleteAccountConfirm).submit();
        });
    }
    showModal() {
        this.modalElement.classList.remove(this.modalHiddenClass);
    }
    hideModal() {
        this.modalElement.classList.add(this.modalHiddenClass);
    }
}
